<template>
    <v-dialog
        v-model="dialogVisible"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                class="btnDetails"
                v-bind="attrs"
                v-on="on" 
                icon
                x-large
                dark
                text
                style="background-color: transparent;" 
                @click="dialogVisible = true"
                >
                <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              dark
              color="secondary">
                <v-btn
                    icon
                    dark
                    class="btn btn-primary"
                    @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Detalle Subcategoría Marketplace</v-toolbar-title>

                <template v-slot:extension>
                    <v-tabs v-model="tab" align-with-title>
                      <v-tabs-slider color="accent"></v-tabs-slider>
    
                      <v-tab v-for="item in items" :key="item">
                        {{ item }}
                      </v-tab>
                    </v-tabs>
                </template>

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <detailsSubcategoriesMarkeplaceComponent
                  :subcategory="subcategoryProps"
                  />
                </div>
              </v-tab-item>

          </v-tabs-items>

  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import detailsSubcategoriesMarkeplaceComponent from '@/views/categories_marketplace/pages/detail_subcategories_marketplace/components/form_detail_subcategories_marketplace_component.vue';
  
  export default {
    
    name:"detailsSubcategory",
    components: {
      detailsSubcategoriesMarkeplaceComponent,
    },
    

    props: {
      subcategoryProps: {
        required: true
      },
    },

    data () {
      return {
        dialogVisible: false,
        tab: null,
        lista: [],
        items: [
          "Datos Completos",
        ],
   
      }
      
    },
    methods: {
      closeDialog() {
        this.dialogVisible = false;
      },

    },
  
    computed: { 
   
    }

    

  };
</script>
  
<style lang="css" scoped>
  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 18px;
  }
</style>
  